module.exports = __webpack_public_path__ + "static/img/orangutan-6-detached.3e02e7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/amenities/tables/orangutan-6-detached.jpg
// module id = 646
// module chunks = 0